import gsap from "gsap";


document.addEventListener('DOMContentLoaded', () => {
  const timeLine = gsap.timeline()


  const modalCallback = document.querySelectorAll('.modal-callback')
  const duration = .3
  const delay = 0

  if (modalCallback) {
    modalCallback.forEach(modalCallback => {
      const modalForm = modalCallback.querySelector('.modal-callback__form')
      const modalAccess = modalCallback.querySelector('.modal-callback__access')
      const modalContent = modalCallback.querySelector('.modal-callback__application')
      const modalInputs = modalForm.querySelectorAll('.modal-callback__input')
      const accessButton = modalForm.querySelector('.modal-callback__button')

      if(modalInputs && accessButton) {
        const checkInput = (value, error) => {
          if (!value.trim()) {
            error.classList.add('input-wrapper__error--view')
          } else {
            error.classList.remove('input-wrapper__error--view')
          }
        }

        modalInputs.forEach(modalInput => {
          const input = modalInput.querySelector('.input-wrapper__input')
          if(input && input.name === 'phone') {
            const deleteChars = () => {
              input.value = input.value.replace(/[^0-9-+()]/g, '');
            }

            input.addEventListener('input', deleteChars)
            input.addEventListener('change', deleteChars)
          }
        })

        const checkInputs = () => {
          let disabled = false

          modalInputs.forEach(input => {
            const modalInput = input.querySelector('.input-wrapper__input')
            const modalInputError = input.querySelector('.input-wrapper__error')

            modalInput.addEventListener('input', e => {
              checkInput(modalInput.value, modalInputError)
            })

            if (!modalInput.value.trim()) {
              disabled = true
              modalInputError.classList.add('input-wrapper__error--view')
            } else {
              modalInputError.classList.remove('input-wrapper__error--view')
            }

            if(modalInput.value.trim() && modalInput.name === 'email') {
              const emailRegular = /\S{2,20}@\S{3,20}\.\S{2,7}/
              const checkEmail = emailRegular.test(modalInput.value)
              if(checkEmail) {
                modalInputError.classList.remove('input-wrapper__error--view')
                modalInputError.innerHTML = 'This field should not be empty'
              } else {
                disabled = true
                modalInputError.classList.add('input-wrapper__error--view')
                modalInputError.innerHTML = 'You have entered an incorrect email'
              }
            }
          })

          return disabled
        }

        modalForm?.addEventListener('applyForm', () => {
          if (!checkInputs()) {
            // timeLine.to(modalContent, {opacity: 0, duration, delay})
            // timeLine.to(modalContent, {display: 'none', duration: 0, delay})
            // timeLine.to(modalAccess, {display: 'block', duration: 0, delay}, '>')
            // timeLine.to(modalAccess, {opacity: 1, duration, delay})
          }
        })
        accessButton.addEventListener('click', checkInputs)
      }
    })
  }
})